<template>
  <div class="relative">
    <!-- <img src="@/assets/images/line/Vector 9.png" alt="lineimg" class="m-auto" /> -->
    <!-- <div class="absolute h-full lg:hidden md:hidden block -mt-40px">
      <img
        src="../../../assets/images/line/hcp-line-2.svg"
        alt="bg"
        class="object-cover"
      />
    </div> -->
    <!-- <div class="flex justify-center md:pt-0 lg:pt-0 pt-0">
      <div
        class="borderprimary md:p-4 lg:p-4 p-0 absolute lg:top-32 md:top-32 top-0 rounded-2xl z-10 lg:w-auto md:w-auto w-10/12"
      >
        <div
          class="md:flex lg:flex items-center lg:p-6 md:p-6 p-4 bgcceff2 rounded-2xl"
        >
          <p class="font-semibold text-black fsize20 sm-fsize14">
            Register for upskilling
            <span class="lg:block md:block"> and job opportunity</span>
          </p>
          <div
            class="md:pl-14 lg:pl-14 md:pt-0 lg:pt-0 pt-2 items-center flex lg:mx-auto md:mx-auto mob-justify-center"
          >
           
            <base-button
              @click="handleClickRedirection('volunteer-register')"
              type="primary"
              class="py-2 px-8 text-base font-bold border-2 md:w-auto lg:w-auto w-full fsize16-14"
              >Sign up</base-button
            >
            
          </div>
        </div>
      </div>
    </div> -->
    <div class="relative md:py-0 lg:py-0 py-4">
      <div class="absolute bg-design4 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd4.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div class="absolute bg-design-cs mob-hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design-cs22 mob-hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <p
        class="lg:mt-10 md:mt-0 mt-6 title sm-fsize16 md:font-normal lg:font-normal font-bold"
      >
        Case Studies
      </p>
      <div
        class="lg:flex md:flex lg:gap-10 md:gap-10 lg:mt-0 md:mt-0 mt-2 items-center"
      >
        <div class="lg:w-1/2 md:w-1/2 w-full flex items-center">
          <div class="relative">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/case-study.jpg"
              alt=""
              class="m-auto custborderradius"
            />
          </div>
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full z-10 lg:mt-0 md:mt-0">
          <div class="relative">
            <p
              class="subtitle lg:pt-0 md:pt-0 lg:pt- 4 md:pt-4 pt-2 lh32px sm-fsize13 sm-lh22"
            >
              <i class="fsize15px">
                “People were dying left, right and centre… not a sight we see on
                a daily basis either. Emotionally it was difficult… scary
                because we had to think of our family also”
              </i>
            </p>
            <p
              class="subtitle lg:pt-10 md:pt-10 pt-4 lh32px sm-lh28 sm-fsize13"
            >
              Dr. Manish is a spine and joint replacement surgeon in a hospital
              in Mumbai. During the COVID 19 pandemic, his overall skills and
              expertise as a medical practitioner were in great demand.
              <span class="mob-hidden"
                >There was enormous pressure on the limited resources of the
                entire healthcare system. The virus was spreading rapidly and
                many of those infected were critical and required
                hospitalization.</span
              >
            </p>
            <p
              class="subtitle lg:pt-6 md:pt-6 pt-2 lh32px sm-fsize14 mob-hidden"
            >
              The primary role of a medical worker like Dr.Manish is the duty to
              care. He worked very hard to heal and save the lives of patients
              every day.
            </p>
            <!-- <p
              class="subtitle lg:pt-6 md:pt-6 pt-2 lh32px sm-fsize14 mob-hidden"
            >
              With aged parents and a young child at home, Dr. Manish felt
              immense anxiety of his personal risk while caring for infected
              patients. He stayed away from his family for many months
            </p> -->
          </div>
          <div class="md:pt-10 lg:pt-10 pt-4">
            <a
              href="https://caregiversaathi.co.in/insights/blogsPage/61b1ddf6e2307600112fe010"
            >
              <base-button
                outline
                type="primary"
                class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2 fsize16-14"
                @click="handleClick"
                >Read More</base-button
              ></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import casestudyMixin from "@/mixins/casestudy";

export default {
  mixins: [casestudyMixin],
  methods: {
    handleClick() {
      this.openCaseStudy("Case Study: Duty to Care");
    },
    handleClickRedirection(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style>
@media (max-width: 640px) {
  .sm-h740px {
    height: 740px;
  }
}
@media (min-width: 641px) {
  .topmiu50 {
    top: -50px;
  }
  .h-730px {
    height: 730px;
  }
}
</style>
